<template>
  <form name="logon" id="logon" @submit.prevent.stop="loginSubmit">
    <transition name="fade" appear>
      <div class="redBold" v-if="message.length > 0">{{ message }}</div>
    </transition>
    <ul>
      <li>
        <div>Username</div>
        <span class>
          <input
            type="text"
            name="email"
            autocomplete="off"
            maxlength="50"
            v-model="username"
          />
        </span>
      </li>
      <li>
        <div>Password</div>
        <span>
          <input
            type="password"
            name="password"
            value
            autocomplete="off"
            v-model="password"
          />
        </span>
      </li>
      <li>
        <router-link to="/forgot_email" class="forgot-password"
          >Forgot Password?</router-link
        >
      </li>
      <li>
        <input
          type="submit"
          value="Login"
          class="marginTop buttonstyle right"
          name="sublogin"
          v-if="!loading"
        />
        <span class="loader-container-auth" v-else>
          <span class="loader"></span>
        </span>
      </li>
      <li id="loginSubscribe" class="paddingTop">
        <p></p>
      </li>
      <li class="textMiddle">
        <img :src="comodo" class alt="Wildcard SSL" width="76" height="26" />
      </li>
      <li>
        <div class="error-message">{{ bottomMessage }}</div>
      </li>
    </ul>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  FULL_TEST_SITE_LINK,
  FULL_PROD_SITE_LINK
} from "../../../store/config";

export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    ...mapActions({
      login: "login"
    }),
    ...mapMutations({
      setMessage: "setMessage",
      toggleShowSplitScreenMonthly: "toggleShowSplitScreenMonthly"
    }),
    /**
     * Function when ever login form has been submitted
     */
    loginSubmit() {
      const username =
        this.username.trim().length > 0 ? this.username.trim() : false;
      const password =
        this.password.trim().length > 0 ? this.password.trim() : false;

      if (username && password) {
        this.login({
          username,
          password
        })
          .then(() => {
            if (!this.showSplitScreenMonthly) {
              this.toggleShowSplitScreenMonthly();
            }
            if (!this.nextRoute) {
              this.$router.push("/daily");
            } else {
              this.$router.push(this.nextRoute);
            }
          })
          .catch(() => {
            // Do nothing
          });
      } else {
        this.setMessage("Please enter username and password");
      }
    }
  },
  computed: {
    ...mapGetters({
      message: "getMessage",
      loading: "getLoadingAuth",
      nextRoute: "getNextRoute",
      bottomMessage: "getBottomMessage",
      showSplitScreenMonthly: "getShowSplitScreenMonthly"
    }),
    comodo() {
      return require("../../../assets/img/sectigo_trust_seal_md_106x42.png");
    },
    forgotPasswordLink() {
      if (document.URL.match("test")) {
        return FULL_TEST_SITE_LINK + "/forgotpwd.php";
      }
      return FULL_PROD_SITE_LINK + "/forgotpwd.php";
    }
  }
};
</script>

<style scoped>
@media (max-width: 375px) {
  form#logon div.redBold {
    padding-bottom: 0 !important;
  }

  ul {
    width: auto !important;
    margin: 15px auto !important;
  }
}

form {
  padding: 0;
}

form#logon div.redBold {
  margin: 10px 0 0;
  width: 100%;
  line-height: 1.5em;
  text-align: center;
}

.redBold {
  font-size: 13px;
  color: #e50404;
  font-weight: 800;
}

.noDisplay {
  display: none;
}

.loginTable ul {
  padding: 0;
  width: 280px;
  margin: 30px auto;
  list-style: none;
}

.loginTable ul li {
  width: 100%;
  padding: 6px 0;
  display: block;
  margin-bottom: 10px;
}

.loginTable ul li div {
  margin-top: 3px;
  font-weight: lighter;
  font-style: inherit;
  line-height: 1;
  text-align: left;
  vertical-align: baseline;
  font-size: 16px;
  color: #878787;
  margin-bottom: 5px;
}

.loginTable ul li span {
  display: block;
  width: 100%;
}

.loginTable ul li a {
  font-size: 14px;
  display: block;
  margin-top: -10px;
}

.loginTable ul li a:hover {
  text-decoration: underline;
}

.loginTable ul li span input {
  width: 100%;
  border: solid 1px #e3e9ef;
  font-size: 16px;
  -webkit-appearance: textfield;
  background-color: white;
  -webkit-rtl-ordering: logical;
  cursor: text;
  color: #595959;
  padding: 7px 5px;
}

.loginTable ul li span.loader-container-auth {
  width: 8px;
  background: none;
}

.loginTable ul li input[type="submit"] {
  background-color: #d26d13;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
  border: 0px;
  -webkit-appearance: button;
  border-radius: 3px;
  padding: 6px 0.9em 6px 0.9em;
  margin-top: 0px;
  width: 100%;
  display: block;
  padding: 10px;
  font-size: 16px;

  border: 1px solid #ae5003;
}

.loginTable ul li input[type="submit"]:hover {
  background-color: #e56700;
}

.loginTable .error-message {
  color: #d26d13;
  font-size: 14px;
  margin: 20px auto 30px;
  text-align: center;
}

.loader-container-auth {
  padding: 3px 13px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  text-decoration: none;
  font-weight: 400;
  box-shadow: 0.7px 0.7px 0.2px 0;
  width: 39.1562px;
  margin: 5px auto;
}

.loader {
  border: 5px solid #c3af7e;
  border-top: 5px solid #fff;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  animation: spin 0.5s linear infinite;
}

.marginTop {
  margin-top: 20px;
}

.right {
  float: right;
}

.loginTable img {
  display: block;
  margin: 0 auto;
}

.loginTable ul li#loginSubscribe p {
  margin: 0px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 400px) {
  .loginTable ul {
    margin: 21px auto;
  }
}

@media screen and (max-width: 812px) and (max-height: 376px) {
  .loginTable ul {
    margin: 0px auto;
  }
  form#logon div.redBold {
    padding-bottom: 0px;
    font-size: 11px;
    margin-top: 0px;
  }
}
</style>
